import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=2b9e1934&scoped=true&"
import script from "./Page.ts?vue&type=script&lang=ts&"
export * from "./Page.ts?vue&type=script&lang=ts&"
import style0 from "./Page.scss?vue&type=style&index=0&id=2b9e1934&prod&lang=scss&scoped=true&"
import style1 from "@dasgate/uikit/lib/index.css?vue&type=style&index=1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9e1934",
  null
  
)

export default component.exports